import { StyleSheet } from 'react-native'

export default StyleSheet.create({
  container: {
    marginHorizontal: 16,
    flexDirection: 'row',
    alignItems: 'baseline'
  },
  smallLabel: {
    lineHeight: 34
  }
})
